import { render } from "./EcoConcious.vue?vue&type=template&id=6e2a2bff&scoped=true"
import script from "./EcoConcious.vue?vue&type=script&lang=js"
export * from "./EcoConcious.vue?vue&type=script&lang=js"

import "./EcoConcious.vue?vue&type=style&index=0&id=6e2a2bff&scoped=true&lang=css"

import exportComponent from "/Users/pongsakornsomsri/workspace/neera-retreat-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e2a2bff"]])

export default __exports__